/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface WithNoLimit
 */
export interface WithNoLimitOptional {
  /**
   *
   * @type {boolean}
   * @memberof WithNoLimit
   */
  noLimit?: boolean;
}

export interface WithNoLimit extends WithNoLimitOptional {
  /**
   *
   * @type {boolean}
   * @memberof WithNoLimit
   */
  noLimit?: boolean;
}

export interface WithNoLimitTrackedI {
  /**
   *
   * @type {boolean}
   * @memberof WithNoLimit
   */
  noLimit?: boolean;
  noLimitIsSet: boolean;
}

transformDatesMap.set("WithNoLimit", function (model: WithNoLimit) {});

export type WithNoLimitMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  noLimit: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var WithNoLimitMeta: WithNoLimitMetaI = {} as WithNoLimitMetaI;
WithNoLimitMeta = typeMeta("WithNoLimit", {
  noLimit: propertyMeta("noLimit", false, false, false, MetaTypesBase.boolean),
});

const metaI = WithNoLimitMeta;

registerMeta(() => {});

export class WithNoLimitTracked implements WithNoLimitTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  noLimit__I?: boolean = undefined;
  noLimitIsSet: boolean = false;
  set noLimit(v: undefined | boolean) {
    if (v !== undefined) {
      this.noLimit__I = v;
      this.noLimitIsSet = true;
    } else {
      this.noLimit__I = v || undefined;
      this.noLimitIsSet = false;
    }
    this.changeTracker = true;
  }
  get noLimit() {
    return this.noLimit__I;
  }
  constructor(config?: WithNoLimitOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: WithNoLimitOptional,
    options?: AssignOptions,
  ): WithNoLimitTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.noLimit && this.noLimitApplyFilter(optionsRequired.filter)) {
      this.noLimit = config.noLimit;
      if (optionsRequired.unassign) this.noLimitIsSet = false;
      else this.noLimitIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): WithNoLimitTrackedI {
    const cloned = {} as WithNoLimitTrackedI;
    if (
      this.noLimitIsSetDeep() &&
      this.noLimitApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.noLimitIsSet = true;
      cloned.noLimit = this.noLimit;
    } else {
      //cloned.noLimitIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): WithNoLimitTrackedI {
    if (!this.noLimitApplyFilter(filter)) this.noLimitIsSet = false;

    return this;
  }
  noLimitApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(WithNoLimitMeta.noLimit, WithNoLimitMeta, this.noLimit, this);
  }
  noLimitIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.noLimitIsSet && this.noLimitApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.noLimitIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
